import React from 'react';
import { MapPin } from 'lucide-react';
export function CommerceDistance() {
  return <section className="bg-charcoal text-white py-6" data-id="element-731">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-3" data-id="element-732">
        <MapPin className="w-6 h-6 text-storm-red" data-id="element-733" />
        <span className="text-lg font-bold uppercase tracking-wide" data-id="element-734">
          A short drive from Commerce Township
        </span>
      </div>
    </section>;
}